import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import conditionSurvey from "../../static/images/services/condition_survery_onhire.png";
import dryBoxService from "../../static/images/services/dry_box_service.png";
import eiReceipt from "../../static/images/services/ei_receipt.jpg";
import tankInspection from "../../static/images/services/tank_inspection_report.png";
import tankCleaning from "../../static/images/services/tc.jpg";
import service from "../../static/images/services/service.png";

const Services = () => {
  const mainServices = [
    {
      title: 'IMO Tank Container Certification',
      description: 'Comprehensive checking and issuing of cleanliness certificates for all IMO tank containers. We ensure compliance with international maritime standards and regulations.',
      image: tankCleaning,
      features: [
        'Pre-loading inspection and certification',
        'Cleanliness verification',
        'Safety compliance checks',
        'Documentation and reporting',
        'Quick turnaround time'
      ],
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      )
    },
    {
      title: 'Condition Survey Import/Export',
      description: 'Detailed condition surveys during import and export operations from Mumbai Port and JNPT. Our surveyors provide accurate assessments and comprehensive documentation.',
      image: eiReceipt,
      features: [
        'Pre-shipment inspections',
        'Damage assessment and reporting',
        'Photographic evidence documentation',
        'Cargo condition verification',
        'Compliance with international standards'
      ],
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
      )
    },
    {
      title: 'On/Off Hire Survey',
      description: 'Professional on-hire and off-hire surveys of marine containers. We provide detailed condition reports to protect your interests during container lease transitions.',
      image: conditionSurvey,
      features: [
        'Complete container inspection',
        'Structural integrity assessment',
        'Door and seal verification',
        'Interior and exterior condition check',
        'Detailed photographic records'
      ],
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
        </svg>
      )
    },
    {
      title: 'Pre & Post Repair Survey',
      description: 'Comprehensive pre and post repair surveys for dry van, reefer, and tank containers. Ensuring quality repairs and proper documentation for all stakeholders.',
      image: dryBoxService,
      features: [
        'Damage identification and assessment',
        'Repair scope determination',
        'Quality verification after repairs',
        'Cost estimation support',
        'Warranty compliance verification'
      ],
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      )
    },
    {
      title: 'Tank Inspection Report',
      description: 'Professional inspection and certification reports for ISO tank containers ensuring safety and compliance with IMDG, IMO, and international transport regulations.',
      image: tankInspection,
      features: [
        'Structural integrity check',
        'Valve and fitting inspection',
        'Lining and coating assessment',
        'Safety equipment verification',
        'Leakage and pressure testing'
      ],
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      )
    }
  ];

  const additionalServices = [
    {
      title: 'Marine Cargo Survey',
      description: 'Complete cargo inspection and damage assessment services',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
      )
    },
    {
      title: 'Draft Survey',
      description: 'Accurate draft survey for bulk cargo vessels',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      )
    },
    {
      title: 'Bunker Survey',
      description: 'Fuel quantity verification and quality testing',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      )
    },
    {
      title: 'Loading/Discharge Supervision',
      description: 'Professional supervision during cargo operations',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      )
    },
    {
      title: 'Hold Inspection',
      description: 'Detailed vessel hold cleanliness and condition inspection',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      )
    },
    {
      title: 'Marine Consultancy',
      description: 'Expert advice on maritime operations and compliance',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
        </svg>
      )
    }
  ];

  const whyChooseUs = [
    {
      title: 'Certified Professionals',
      description: 'Our team consists of highly qualified and certified marine surveyors with extensive industry experience.'
    },
    {
      title: 'Quick Response Time',
      description: 'We understand the importance of time in maritime operations and provide rapid survey services without compromising quality.'
    },
    {
      title: 'Comprehensive Reports',
      description: 'Detailed, accurate, and professional reports with photographic evidence and clear recommendations.'
    },
    {
      title: 'Global Standards',
      description: 'All our services comply with international maritime standards and regulations.'
    },
    {
      title: 'Competitive Pricing',
      description: 'Transparent and competitive pricing structure with no hidden costs.'
    },
    {
      title: '24/7 Availability',
      description: 'Round-the-clock availability for emergency surveys and consultations.'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[70vh] mt-20 overflow-hidden">
        <img
          src={service}
          alt="Marine Services"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40">
          <div className="container mx-auto px-4 h-full flex items-center">
            <div className="max-w-3xl text-white">
              <h1 className="text-5xl md:text-6xl font-bold mb-6">Our Services</h1>
              <p className="text-xl md:text-2xl text-blue-100 mb-8">
                Comprehensive marine consultancy and survey solutions tailored to your needs
              </p>
              <a
                href="#main-services"
                className="inline-block px-8 py-4 bg-white text-blue-600 font-bold rounded-lg hover:bg-blue-50 transition-all shadow-2xl hover:shadow-3xl transform hover:-translate-y-1"
              >
                Explore Our Services
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Services Section */}
      <section id="main-services" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Core Services</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We provide professional marine survey and consultancy services with a commitment to excellence and accuracy
            </p>
          </div>

          <div className="space-y-16">
            {mainServices.map((service, index) => (
              <div
                key={index}
                className={`flex flex-col ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                } gap-8 lg:gap-12 items-center`}
              >
                <div className="w-full lg:w-1/2">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-[400px] object-cover rounded-2xl shadow-2xl"
                  />
                </div>
                
                <div className="w-full lg:w-1/2">
                  <div className="text-blue-600 mb-4">{service.icon}</div>
                  <h3 className="text-3xl font-bold text-gray-800 mb-4">{service.title}</h3>
                  <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                    {service.description}
                  </p>
                  <div className="space-y-3">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start gap-3">
                        <svg className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        <span className="text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services Section */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Additional Services</h2>
            <p className="text-lg text-gray-600">
              Expanding our expertise to cover all your maritime needs
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {additionalServices.map((service, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:transform hover:-translate-y-2"
              >
                <div className="text-blue-600 mb-4">{service.icon}</div>
                <h4 className="text-xl font-bold text-gray-800 mb-3">{service.title}</h4>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Why Choose Our Services</h2>
            <p className="text-lg text-gray-600">
              What sets us apart in the maritime industry
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {whyChooseUs.map((item, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-blue-50 to-white p-8 rounded-2xl border border-blue-100 hover:shadow-xl transition-all duration-300"
              >
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h4 className="text-xl font-bold text-gray-800 mb-3">{item.title}</h4>
                <p className="text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Process Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">Our Service Process</h2>
            <p className="text-xl text-blue-100">
              Simple, efficient, and transparent workflow
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {[
              { step: '01', title: 'Initial Contact', desc: 'Reach out to us with your requirements' },
              { step: '02', title: 'Assessment', desc: 'We evaluate your needs and provide a quote' },
              { step: '03', title: 'Survey Execution', desc: 'Our experts conduct the survey professionally' },
              { step: '04', title: 'Report Delivery', desc: 'Receive comprehensive reports promptly' }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-white text-blue-600 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4">
                  {item.step}
                </div>
                <h4 className="text-xl font-bold mb-2">{item.title}</h4>
                <p className="text-blue-100">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center bg-gradient-to-br from-blue-50 to-white p-12 rounded-3xl shadow-xl">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Need Our Services?</h2>
            <p className="text-xl text-gray-600 mb-8">
              Get in touch with us today for professional marine consultancy and survey services
            </p>
            <div className="flex gap-4 justify-center flex-wrap">
              <a
                href="/contact-us"
                className="px-8 py-4 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Contact Us
              </a>
              <a
                href="tel:+919821015469"
                className="px-8 py-4 border-2 border-blue-600 text-blue-600 font-bold rounded-lg hover:bg-blue-600 hover:text-white transition-all"
              >
                Call Now
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Services;